/* 14.10.2026: "Pokaz wiecej" w kolekcji (snippets/lv-paginacja.liquid, wariant A z kanwy Tuw4R5q1eVS8RU4tYPvbYm).
   Dogrywa nastepna strone przez Section Rendering API (?page=N&section_id=...), dopisuje karty do #product-grid, podmienia
   przycisk i numery stron, a adres zmienia na ?page=N (replaceState), wiec odswiezenie i powrot trafiaja na ta strone.
   Filtrow nie przerysowuje. Delegacja na document, bo facets.js po filtrowaniu podmienia cale #ProductGridContainer.
   Bez fetch / przy bledzie zwykle przejscie linkiem. */
(function () {
  if (window.lvPokazWiecej) return;
  window.lvPokazWiecej = true;

  /* 27.10.2026: jednostka z data-jedn / data-jedn-mn (kolekcja: produktow / produkty, wyszukiwarka: wynikow / wyniki) */
  function tekst(od, doN, wszystkie, pag) {
    var j = (pag && pag.dataset.jedn) || 'produktów';
    var jm = (pag && pag.dataset.jednMn) || 'produkty';
    return od === 1
      ? 'Wyświetlono ' + doN + ' z ' + wszystkie + ' ' + j
      : 'Wyświetlono ' + jm + ' ' + od + '-' + doN + ' z ' + wszystkie;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-lv-wiecej]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var siatka = document.getElementById('product-grid');
    var pag = a.closest('.lv-pag');
    if (!siatka || !pag || !siatka.dataset.id || !window.fetch || !window.DOMParser) return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    a.classList.add('is-loading');

    var adres = new URL(a.href, location.href);
    var zapytanie = new URL(adres.toString());
    zapytanie.searchParams.set('section_id', siatka.dataset.id);

    fetch(zapytanie.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var dok = new DOMParser().parseFromString(html, 'text/html');
        var nowa = dok.getElementById('product-grid');
        var nowaPag = dok.querySelector('.lv-pag');
        if (!nowa || !nowaPag) throw new Error('brak siatki w odpowiedzi');
        /* kafel promocji, Oferty limitowanej i banery sa juz na pierwszej stronie - dopisujemy same produkty */
        nowa.querySelectorAll(':scope > .lv-promo-kafel, :scope > .lv-ol-kafel, :scope > .banner-item, :scope > .lv-belka-ank').forEach(function (x) {
          x.remove();
        });
        var bylo = siatka.children.length;
        siatka.insertAdjacentHTML('beforeend', nowa.innerHTML);

        var od = parseInt(pag.dataset.od, 10) || 1;
        var doN = parseInt(nowaPag.dataset.do, 10);
        var wszystkie = parseInt(nowaPag.dataset.wszystkie, 10);
        pag.dataset.do = doN;
        pag.querySelector('.lv-pag__ile').textContent = tekst(od, doN, wszystkie, pag);
        var pasek = pag.querySelector('.lv-pag__pasek');
        if (pasek && wszystkie) {
          pasek.style.left = ((od - 1) * 100 / wszystkie).toFixed(2) + '%';
          pasek.style.width = ((doN - od + 1) * 100 / wszystkie).toFixed(2) + '%';
        }
        var nowyPrzycisk = nowaPag.querySelector('[data-lv-wiecej]');
        if (nowyPrzycisk) a.replaceWith(nowyPrzycisk);
        else a.remove();
        var strony = pag.querySelector('.lv-pag__strony');
        var noweStrony = nowaPag.querySelector('.lv-pag__strony');
        if (strony && noweStrony) strony.replaceWith(noweStrony);

        var szukane = adres.search.slice(1);
        history.replaceState({ searchParams: szukane }, '', adres.pathname + adres.search);
        /* facets.js przy cofaniu porownuje stan z searchParamsPrev/Initial - bez tego cofniecie po filtrze pokazaloby strone 1 pod adresem ?page=N */
        if (typeof FacetFiltersForm !== 'undefined') {
          FacetFiltersForm.searchParamsPrev = szukane;
          FacetFiltersForm.searchParamsInitial = szukane;
        }

        /* fokus na pierwszy dograny produkt (czytniki ekranu, klawiatura), bez przewijania */
        var pierwszy = siatka.children[bylo];
        var link = pierwszy && pierwszy.querySelector('a[href]');
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function (err) {
        console.error('lv-pokaz-wiecej', err);
        location.href = a.href;
      });
  });
})();
